export const isE2EMockApi = () =>
  process.env.E2E_MOCK_API === "1" && process.env.NODE_ENV !== "production";

export const getE2EAuthorization = () => ({
  access_token: "e2e-access-token",
  refresh_token: "e2e-refresh-token",
  token_type: "Bearer",
  email: "e2e-user@gmail.com",
});

export const getE2EUserProfile = () => ({
  id: 10001,
  email: "e2e-user@gmail.com",
  gender: 1,
  has_subscription: false,
  personal_information: {
    body_type: "skinny",
    body_goal: "beach-body",
    target_areas: ["sixpack-abs"],
    additional_goals: ["feel-more-energized"],
    target_weight_kg: 55,
    workout_count: 1,
    occasion: "beach-trip",
    bmi: 20.76,
    personalized_plan_parameter: {
      goal: "Lose Weight",
      height_cm: 170,
      weight_kg: 60,
      target_weight_kg: 55,
      fit_level: "beginner",
      daily_activity: "Sedentary",
      training_days: [1, 2, 4, 5],
      week_length: 4,
      workout_over_1_month: false,
    },
  },
});

const flashsalePlan = (durationAmount, basePrice, litePrice, liteDiscount, fullPrice, fullDiscount) => ({
  label: `${durationAmount} ${durationAmount === 1 ? "Month" : "Months"} Plan`,
  discount_label: durationAmount === 2 ? "Extra 30%" : "",
  packages: [
    {
      id: durationAmount * 100,
      name: `${durationAmount} ${durationAmount === 1 ? "Month" : "Months"} Subscription`,
      validity_period_amount: durationAmount,
      price: basePrice,
      price_text: `Rp${basePrice.toLocaleString("id-ID")}`,
      retail_price: `Rp${basePrice.toLocaleString("id-ID")}`,
      fs_pl_retail_price: basePrice,
      fs_pl_first_price: litePrice * durationAmount,
      fs_pl_first_ppm: litePrice,
      fs_pl_first_pct: liteDiscount,
      fs_pl_recurring_price: basePrice,
      fs_fp_first_price: fullPrice * durationAmount,
      fs_fp_first_ppm: fullPrice,
      fs_fp_first_pct: fullDiscount,
      fs_fp_recurring_price: basePrice,
      pricing: {
        monthly_price_text: {
          normal: `Rp${basePrice.toLocaleString("id-ID")}`,
          promo: `Rp${litePrice.toLocaleString("id-ID")}`,
        },
        main_price_text: `Rp${litePrice.toLocaleString("id-ID")}`,
        sub_price_text: null,
        period_text: "/month",
        next_billing_text: "",
      },
    },
  ],
});

export const getE2ELandingPageContent = () => ({
  highest_percentage: 75,
  discount_percentage: 75,
});

export const getE2EWorkoutLanding = () => ({
  bogo: {
    enabled: false,
    title: "",
  },
  can_switch_country: false,
  check_voucher: {},
  enabled_package_types: {
    subscription: true,
    single_purchase: true,
  },
  fitness_in_your_pocket_summary: [
    "Personalized workouts",
    "Meal guidance",
    "Progress tracking",
  ],
  headings: {
    "personalized-program-ready": "Your personalized program is ready",
  },
  images: {
    fitness_in_your_pocket: "/static/new-landing-page/overview/en.webp",
  },
  package_footer: "Flashsale price is available for a limited time.",
  package_header: "Choose your flashsale plan",
  personalized_program_target: {
    images: {
      now: "/static/images/landing/step_3/image_skinny_male.png",
      goal: "/static/images/landing/step_4/image_beach_body.png",
    },
    target_calorie: {
      value: 1800,
      unit: "kcal/day",
    },
  },
  plan: [
    flashsalePlan(1, 100000, 59000, 41, 97000, 22),
    flashsalePlan(2, 200000, 41000, 59, 68000, 46),
  ],
  proof_widget: {
    buyer_past_24_hours: {
      title: "12 people joined today",
      subtitle: "Flashsale is active",
    },
    last_buyer: {
      title: "New member joined",
      location: "Jakarta",
      subtitle: "Bought Premium Pro",
      purchase_time: "just now",
      avatar_url: "",
    },
    last_buyers: [],
  },
  selling_price_plan: [],
  testimonial: [
    "/static/new-landing-page/testimony/testimonial_1.png",
  ],
  voucher: {
    category: null,
    is_applied: false,
    validation: {},
  },
});
